import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import { goToLogin } from 'helpers/noSession';
// import HowWorkSection from 'containers/howWorks';
import Detail from './Detail';
import TermsAndConditions from '../termsAndConditions';
import NoPoints from './NoPoints';

const DetailComp = ({ detail }) => {
  const navigate = useNavigate();

  const { termsConditions, status } = detail;

  const ErrorPage = () => {
    navigate('/errorOffer');
  };

  const ErrorStaffPage = () => {
    navigate('/errorStaff');
  };

  const ErrorConsecutivePage = () => {
    navigate('/errorConsecutive');
  };

  // Offer State
  const { statusOffer } = useSelector((state) => state.offer);
  const { error, type } = useSelector((state) => state.offer.offer);

  return (
    <>
      {(!error || (error && type === 'offerOvered')) && (
        <Container fluid className="bg-white">
          <Container>
            <Detail
              detail={detail} />
          </Container>
          <Row className={status === 'CLOSED' || status === 'CLOSED_WITH_WINNERS' ? 'd-none' : 'mt-60'}>
            {/* <HowWorkSection
              backgroundColor="bg-alabaster" /> */}
            <TermsAndConditions
              termsConditions={termsConditions} />
          </Row>
        </Container>
      )}

      {error && type === 'NoPoints' && <NoPoints />}
      {statusOffer === 'success' && error && type === 'General' && ErrorPage()}
      {statusOffer === 'success' && error && type === 'InvalidAccount' && ErrorStaffPage()}
      {statusOffer === 'success' && error && type === 'consecutiveError' && ErrorConsecutivePage()}
      {statusOffer === 'success' && error === 'Forbidden' && goToLogin()}
    </>
  );
};

DetailComp.propTypes = {
  detail: PropTypes.shape({
    title: PropTypes.string.isRequired,
    termsConditions: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default DetailComp;
